import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faHeadset } from '@fortawesome/free-solid-svg-icons';
import { faWeixin } from '@fortawesome/free-brands-svg-icons';

const DemoModal = ({ 
  isOpen, 
  onClose,
  title = "专业演示顾问",
  description = "👋 您好！我是云帐天下的专业演示顾问\n扫描右侧二维码添加微信\n为您提供一对一的产品演示服务",
  qrCodeTitle = "微信扫码预约演示",
  qrCodeSubtitle = "服务时间：每天 8:00-19:00",
  bottomTip = "添加微信后，我们将为您安排专属演示时间，深度展示系统核心功能",
  qrCodeImage = "/service.png",
  qrCodeAlt = "演示顾问微信二维码"
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden relative">
        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors"
        >
          <FontAwesomeIcon icon={faTimes} className="text-gray-600" />
        </button>

        <div className="flex flex-col md:flex-row">
          {/* 左侧 - 专业客服图标 */}
          <div className="md:w-1/2 bg-gradient-to-br from-blue-50 to-indigo-100 p-8 flex flex-col items-center justify-center">
            {/* 专业客服图标 */}
            <div className="mb-6 relative">
              <div className="w-32 h-32 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <FontAwesomeIcon icon={faHeadset} className="text-white text-4xl" />
              </div>
              {/* 在线状态指示 */}
              <div className="absolute -top-2 -right-2 flex items-center">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2">
                <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                  在线服务
                </span>
              </div>
            </div>
            
            <div className="text-center">
              <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                {description}
              </p>
            </div>
          </div>

          {/* 右侧 - 微信二维码 */}
          <div className="md:w-1/2 p-8 flex flex-col items-center justify-center bg-white">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-4 mx-auto">
                <FontAwesomeIcon icon={faWeixin} className="text-white text-2xl" />
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">{qrCodeTitle}</h4>
              <p className="text-gray-600 text-sm">{qrCodeSubtitle}</p>
            </div>
            
            {/* 微信二维码 */}
            <div className="w-48 h-48 bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center">
              <img 
                src={qrCodeImage}
                alt={qrCodeAlt}
                className="w-44 h-44 object-contain"
              />
            </div>
          </div>
        </div>
        
        {/* 底部提示 */}
        <div className="bg-blue-50 px-6 py-4 border-t">
          <div className="flex items-center justify-center text-sm text-gray-600">
            <span className="mr-2">💡</span>
            <span>{bottomTip}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoModal;